import { css, CSSResult } from 'lit'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const rmaDetail: CSSResult = css`
  :host {
    display: block;
  }

  .rma-header {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    margin-bottom: ${csSpacing.spacing08};
  }

  .rma-title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${csSpacing.spacing06};
  }

  .rma-detail__content {
    display: grid;
    grid-template-columns: 1fr;
    gap: ${csSpacing.spacing08};
  }

  .rma-detail__lines {
    min-width: 0;
  }

  .rma-properties {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
  }

  .rma-properties__user {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  .rma-line {
    --cse-paper-row-gap: ${csSpacing.spacing06};
  }

  .rma-line__header {
    display: flex;
    align-items: flex-start;
    gap: ${csSpacing.spacing06};
  }

  .rma-line__image {
    flex: 0 0 auto;
    width: 75px;
    height: 56px;
    --csc-product-image-height-mobile: 56px;
    --csc-product-image-height-desktop: 56px;
    --csc-product-image-aspect-ratio: 1 / 1;
  }

  .rma-line__info {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    min-width: 0;
  }

  .rma-line__quantity {
    flex: 0 0 auto;
    margin-left: auto;
  }

  .rma-line__details {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: ${csSpacing.spacing08};
  }

  .rma-line__detail {
    flex: 0 1 auto;
    min-width: 160px;
  }

  .rma-line__fields {
    display: grid;
    grid-template-columns: 1fr;
    gap: ${csSpacing.spacing06};
  }

  .rma-line__field {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    min-width: 0;
  }

  .rma-line__files {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }

  .rma-empty {
    display: block;
    color: ${csColorText.body};
  }

  @media (min-width: ${SCREENS.small}) {
    .rma-detail__content {
      grid-template-columns: minmax(363px, 1fr) 315px;
      align-items: start;
    }

    .rma-line__fields {
      grid-template-columns: repeat(auto-fit, minmax(303px, 1fr));
    }
  }
`
